namespace RioERP.Web.Enums {
    export enum TawkToEvent {
        ChatStart = 1,
        ChatEnd = 2,
        TicketCreated = 3
    }
    Serenity.Decorators.registerEnumType(TawkToEvent, 'RioERP.Web.Enums.TawkToEvent');
}
